"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var create_document_controller_1 = __importDefault(require("./create-document.controller"));
var create_document_html_1 = __importDefault(require("./create-document.html"));
var document_editor_module_1 = __importDefault(require("../../directives/document-editor/document-editor.module"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.documenttemplates.create", {
        url: "/create-document-template",
        controller: "AdminCreateDocumentTemplateController",
        controllerAs: "ctrl",
        template: create_document_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.documenttemplates.create", [document_editor_module_1.default.name])
    .config(config)
    .controller("AdminCreateDocumentTemplateController", create_document_controller_1.default);
